import HeaderDesktop from "@Components/Header/HeaderDesktop";
import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import PersonalInfoContainer from "../components/PersonalInfoContainer/PersonalInfoContainer";

const ProfileDesktop = () => (
  <div>
    <Helmet title="Third Party Personal Information | Amber" />
    <HeaderDesktop hideAppBanner />
    <PersonalInfoContainer />
    <FooterDesktop />
  </div>
);

export default wrapperHOC(ProfileDesktop, {
  componentName: "ProfileDesktop-ProfileOffers",
  showForChina: true,
});
